import { render } from "./ssologin.vue?vue&type=template&id=49f5a418&scoped=true"
import script from "./ssologin.vue?vue&type=script&lang=js"
export * from "./ssologin.vue?vue&type=script&lang=js"

import "./ssologin.vue?vue&type=style&index=0&id=49f5a418&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f5a418"]])

export default __exports__